import anime from 'animejs';
import type { HTMLAttributes } from 'react';
import { useInViewEffect } from 'react-hook-inview';

import cn from '@/helper/cn';

import FAQ, { type FAQType } from '../components/faq';

type FaqSectionType = {
  title?: string;
  defaultValue?: string[];
  faqs: FAQType['items'];
} & HTMLAttributes<HTMLDivElement>;

const FaqSection = ({
  title,
  defaultValue = ['item-1'],
  faqs,
  className,
  ...props
}: FaqSectionType) => {
  const sectionRef = useInViewEffect(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);

        anime
          .timeline({ loop: false })
          .add({
            targets: '#faq-section h2',
            opacity: [0, 1],
            translateY: [100, 0],
            duration: 1000,
            easing: 'easeOutExpo',
          })
          .add(
            {
              targets: '#faq-section #accordion-base',
              opacity: [0, 1],
              translateX: [100, 0],
              duration: 1000,
              easing: 'easeOutExpo',
            },
            '-=650',
          );
      }
    },
    { threshold: 0.2 },
  );
  return (
    <section
      ref={sectionRef}
      id="faq-section"
      className={cn(
        'relative isolate mx-auto w-full max-w-container overflow-hidden px-10 py-10 lg:px-20 lg:py-24',
        className,
      )}
      {...props}
    >
      <div className="flex-1">
        <FAQ
          type="multiple"
          title={title}
          items={faqs}
          defaultValue={defaultValue}
        />
      </div>
    </section>
  );
};

export default FaqSection;
